import { ChangeDetectionStrategy, Component, inject, input, model } from "@angular/core";
import { ProductGroupEx } from "@front/m19-models";
import {
  IButtonDirective,
  ICheckboxComponent,
  IDropdownMenuComponent,
  IDropdownMenuItemDirective,
  IDropdownMenuTriggerDirective,
  IIconComponent,
  ITableImports,
  ModalService,
} from "@front/m19-ui";
import { TranslocoDirective, TranslocoService } from "@jsverse/transloco";
import { ModalDeleteProductGroupComponent, ProductGroupDeletionModalData } from "../product-group.component";
import { AccountMarketplace } from "@front/m19-api-client";

@Component({
  selector: "tr[app-product-group-row]",
  imports: [
    ITableImports,
    ICheckboxComponent,
    IDropdownMenuComponent,
    IDropdownMenuItemDirective,
    IDropdownMenuTriggerDirective,
    IButtonDirective,
    TranslocoDirective,
    IIconComponent,
  ],
  templateUrl: "./product-group-list-item.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductGroupListItemComponent {
  private readonly modalService = inject(ModalService);
  private readonly translocoService = inject(TranslocoService);

  productGroup = input.required<ProductGroupEx>();
  accountMarketplace = input.required<AccountMarketplace>();
  isReadOnly = input<boolean>(false);
  isRowSelected = model<boolean>(false);

  deleteProductGroup() {
    this.modalService.openModal<ProductGroupDeletionModalData, void>(ModalDeleteProductGroupComponent, {
      modalTitle: this.translocoService.translate("product-group-deletion.product_group_deletion"),
      data: {
        productGroups: [this.productGroup()],
        accountMarketplace: this.accountMarketplace(),
      },
    });
  }
}
